<template>
  <Contract />
</template>

<script>
import Contract from "../../components/Contract/Contract.vue";
export default {
  components: {
    Contract,
  },
};
</script>